import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { NgClass, NgIf } from '@angular/common';
import { Severity } from '../../../models/severity';

@Component({
  selector: 'app-count-box',
  standalone: true,
  imports: [AlertStyleDirective, NgIf, NgClass],
  templateUrl: './count-box.component.html',
  styleUrl: './count-box.component.scss',
})
export class CountBoxComponent {
  @Input() mode: 'cta' | 'view' = 'cta';
  @Input() count = 0;
  @Input() severity: Severity = 'success';
  @Input() icon = '';
  @Input() label = '';
  @Input() key = 'misc';
  @Input() text = '';
  @Input() styleClass = '';
  @Output() details: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Triggers the `details` event emitter with the current key value.
   *
   * @return {void} Does not return a value.
   */
  showDetails(): void {
    this.details.emit(this.key);
  }

  /**
   * Retrieves the corresponding icon class based on the severity type.
   *
   * @return {string} A string representing the font-awesome icon class for the specified severity.
   *                  Returns an empty string if no matching severity is found.
   */
  getIconBySeverity(): string {
    switch (this.severity) {
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'error':
        return 'fas fa-exclamation-circle';
    }

    return '';
  }
}
